<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right" style="align-items: center;">
                <el-checkbox v-model="showEmpty" style="margin-right: 12px;" @change="afterInitialData">显示空行</el-checkbox>
                <!-- <el-date-picker v-model="dateFilter.start" type="date" class="header-input" @input="$forceUpdate()" placeholder="选择起始日期" style="width: 180px;" @change="loadData"></el-date-picker>
                <el-date-picker v-model="dateFilter.end" type="date" class="header-input" @input="$forceUpdate()" placeholder="选择终止日期" style="width: 180px;" @change="loadData"></el-date-picker>
                <el-button type="primary" @click="loadData()">搜索</el-button> -->
            </div>
        </div>
        <el-table :data="filterRecords" style="width: 100%;" row-key="categoryId" border default-expand-all
            :tree-props="{ children: 'children' }">
            <el-table-column prop="categoryName" label="朝代名称"></el-table-column>
            <el-table-column label="类型">
                <template slot-scope="scope">
                    {{ scope.row.categoryMode == 0 ? "通用" : "专用" }}
                </template>
            </el-table-column>
            <el-table-column label="当前库存(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.resalerCount1234 + "枚 | " + scope.row.resalerTotal1234 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="锁定(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.resalerCount5 + "枚 | " + scope.row.resalerTotal5 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="出库(数量/总金额)">
                <template slot-scope="scope">
                    {{ scope.row.resalerCount6 + "枚 | " + scope.row.resalerTotal6 +  "元" }}
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.categoryDate) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="categoryChildOpen(scope.row.categoryId, scope.row.categoryName)" type="text" size="small">子分类</el-button>
                    <!-- <el-button @click="addressOpen(scope.row.customerId, scope.row.customerName)" type="text" size="small">库存详情</el-button> -->
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="80px">
                    <el-form-item label="朝代名称">
                        <el-input v-model="handleInfo.categoryName"></el-input>
                    </el-form-item>
                    <el-form-item label="父级朝代">
                        <el-select v-model="handleInfo.categoryParent" placeholder="请选择" style="width: 100%;">
                            <el-option :key="'0'" :label="'无'" :value="'0'"></el-option>
                            <el-option v-for="item in rootList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="朝代类型">
                        <el-select v-model="handleInfo.categoryMode" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in modes" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="addressTitle" :visible.sync="addressLayer" width="450px" :close-on-click-modal="false">
             <el-descriptions :column="1" border>
                <el-descriptions-item :label-style="{width: '150px'}" v-for="address in addresses">
                    <template slot="label">
                        {{ address.addressName }}
                    </template>
                    {{ address.productCount }}枚
                </el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addressLayer = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 子分类管理 -->
        <el-dialog :title="'【' + mainName + '】子分类'" :visible.sync="isCategoryChildShow" width="50%" :close-on-click-modal="false" @close="isCategoryChildShow = false">
            <CategoryChildComponent :categoryId="mainId"></CategoryChildComponent>
        </el-dialog>
    </div>
</template>
<script>

import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

import { API, doGet } from "@/api/api.js"

import CategoryChildComponent from "@/components/CategoryChildComponent.vue"

export default {
    components: {
        CategoryChildComponent
    },
    mixins: [verifyMixin, listMixin, enumMixin],
    data: function () {
        return {
            isCategoryChildShow: false,
            mainId: "",
            mainName: "",
            showEmpty: true,
            addressTitle: "",
            addressLayer: false,
            rootList: [],
            dataTree: [],
            treeProps: {
                label: "categoryName",
                value: "categoryId",
                children: "children"
            },
            addresses: [],
            filterRecords: [],
            dateFilter: {
                start: "",
                end: ""
            },
            modes: [
                {
                    name: "通用",
                    value: 0
                },
                {
                    name: "专用",
                    value: 1
                },
            ]
        }
    },
    methods: {
        categoryChildOpen(id, name) {
            this.mainId = id;
            this.mainName = name;
            this.isCategoryChildShow = true;
        },
        initialParam: function() {
            this.filterParams.startDate = this.dateFilter.start.getTime() / 1000;
            this.filterParams.endDate = this.dateFilter.end.getTime() / 1000;
        },
        afterInitialData: function() {
            this.filterRecords = [];
            for (let i = 0; i < this.records.length; i++) {
                if (this.showEmpty || this.records[i].resalerCount1234 > 0 || this.records[i].resalerCount5 > 0 || this.records[i].resalerCount6 > 0) {
                    this.filterRecords.push(this.records[i]);
                }
            }
        },
        addressOpen: async function(categoryId, categoryName) {
            this.addressTitle = "【" + categoryName + "】库存详情";
            this.addresses = await doGet(API.ADDRESS.CATEGORY, {categoryId: categoryId});
            this.addressLayer = true;
        },
        // getData: async function () {
        //     this.rootList = await doGet(API.ALL.CATEGORY, {
        //         category_parent: "0"
        //     });
        //     this.dataTree = await doGet(API.TREE.CATEGORY);
        // },
        // getDataTreeWithRoot: function () {
        //     let children = this.getDataTreeRecursive(0);
        //     children.unshift({
        //         categoryId: 0,
        //         categoryName: "当前项",
        //     });
        //     let root = {
        //         categoryId: "0-P",
        //         categoryName: "无",
        //         children: children
        //     }
        //     return [root];
        // },
        // getDataTreeRecursive: function (parent) {
        //     let children = [];
        //     let arr = this.dataList.filter(item => item.categoryParent == parent);
        //     if (arr != null) {
        //         for (let i = 0; i < arr.length; i++) {
        //             let item = JSON.parse(JSON.stringify(arr[i]));
        //             let temp = this.getDataTreeRecursive(arr[i].categoryId);
        //             temp.unshift({
        //                 categoryId: item.categoryId,
        //                 categoryName: "当前项",
        //             });
        //             item.children = temp;
        //             item.categoryId = item.categoryId + "-P";
        //             children.push(item);
        //         }
        //     }
        //     return children;
        // }
    },
    created: function () {
        let now = new Date();
        this.dateFilter.start = new Date(now.getFullYear(), now.getMonth(), 1);
        this.dateFilter.end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        this.size = 1000;
        this.tag = "CATEGORY";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>../../../components/CategoryChildComponent.vue